document.addEventListener('DOMContentLoaded', function() {
  const scrollToTopBtn = document.getElementById('scroll-to-top-btn');
  
  if (!scrollToTopBtn) {
    console.log('Scroll to top button not found');
    return;
  }

  // トップページかどうかを判定
  const isHomePage = window.location.pathname === '/' || window.location.pathname === '';
  const isMobile = window.innerWidth <= 767;
  
  // トップページのSP表示時のみ位置を調整
  if (isHomePage && isMobile) {
    scrollToTopBtn.style.bottom = '80px';
  }

  // スクロール位置を監視
  function handleScroll() {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    const showThreshold = window.innerHeight; // 100vh相当
    
    if (scrollPosition > showThreshold) {
      scrollToTopBtn.classList.add('show');
    } else {
      scrollToTopBtn.classList.remove('show');
    }
  }

  // スムーズスクロール機能
  function scrollToTop() {
    const startPosition = window.pageYOffset;
    const startTime = performance.now();
    const duration = 800; // 0.8秒でスクロール

    function easeInOutQuad(t) {
      return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    }

    function animateScroll(currentTime) {
      const timeElapsed = currentTime - startTime;
      const progress = Math.min(timeElapsed / duration, 1);
      const easedProgress = easeInOutQuad(progress);
      
      window.scrollTo(0, startPosition * (1 - easedProgress));
      
      if (progress < 1) {
        requestAnimationFrame(animateScroll);
      }
    }

    requestAnimationFrame(animateScroll);
  }

  // イベントリスナーを追加
  window.addEventListener('scroll', handleScroll);
  scrollToTopBtn.addEventListener('click', scrollToTop);

  // 初期状態をチェック
  handleScroll();
});